var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-container" },
    [
      _vm.showMenuApp && !_vm.isIpad
        ? _c(
            "div",
            [
              _c(
                "el-drawer",
                {
                  attrs: {
                    withHeader: false,
                    visible: _vm.showApp,
                    direction: "ltr",
                    size: "300px",
                    "modal-append-to-body": false,
                    wrapperClosable: true
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.showApp = $event
                    }
                  }
                },
                [
                  _c("div", { staticClass: "wap-top" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://master-shopvidi.s3.amazonaws.com/index_images/mobile_logo%403x.png"
                      }
                    }),
                    _vm._v(" "),
                    _vm.login
                      ? _c("p", [
                          _c(
                            "span",
                            {
                              staticStyle: { width: "auto", padding: "0 10px" }
                            },
                            [_vm._v("Hello," + _vm._s(_vm.realname))]
                          )
                        ])
                      : _c("p", [
                          _c("span", { on: { click: _vm.showLoginHandle } }, [
                            _vm._v("Login")
                          ]),
                          _vm._v(" "),
                          _vm.isPre
                            ? _c("span", { on: { click: _vm.showSdrLogin } }, [
                                _vm._v("SDR/SR")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { on: { click: _vm.showLoginUpHandle } }, [
                            _vm._v("Sign Up")
                          ])
                        ])
                  ]),
                  _vm._v(" "),
                  _vm.isUseNt
                    ? _c(
                        "div",
                        [
                          _vm.pcPayMenthod.pcNetQualificationStatus ==
                            "completed" ||
                          _vm.pcPayMenthod.pcNetQualificationStatus ==
                            "approved"
                            ? [
                                _c("div", { staticClass: "apply-border" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info" },
                                    [
                                      !_vm.netPayable
                                        ? _c(
                                            "div",
                                            { staticClass: "net-term" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$router.push({
                                                        name: "profile"
                                                      })
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Open net term payment"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tooltipText.split(
                                                      ","
                                                    )[0]
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "info-name" },
                                              [
                                                _c("span", [
                                                  _vm._v("Net terms")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "status color-green"
                                                  },
                                                  [_vm._v("Active")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "money_box" },
                                              [
                                                _c("div", [
                                                  _vm.pcPayMenthod.creditLimit
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "money"
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              "$" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "numFormat"
                                                                  )(
                                                                    _vm
                                                                      .pcPayMenthod
                                                                      .totalCreditLimit
                                                                  )
                                                                )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          !_vm.pcPayMenthod
                                                            .exclusiveAvailableLimit
                                                            ? [
                                                                _vm.increaseStatus
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "shoping_button",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.$router.push(
                                                                              {
                                                                                name:
                                                                                  "apply"
                                                                              }
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Increase My Limit"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "shoping_button"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Review increase limit"
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.pcPayMenthod.creditLimit
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-desc"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Credits available"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]),
                                                _vm._v(" "),
                                                _vm.pcPayMenthod
                                                  .exclusiveAvailableLimit
                                                  ? _c("div", {
                                                      staticClass:
                                                        "line_between"
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.pcPayMenthod
                                                  .exclusiveAvailableLimit
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "money_box_right"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "money"
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                "$" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .pcPayMenthod
                                                                      .exclusiveAvailableLimit
                                                                  )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info-desc"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pcPayMenthod
                                                                  .exclusiveBrandName
                                                              ) + " Credits"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.pcPayMenthod
                                              .exclusiveAvailableLimit
                                              ? [
                                                  _vm.increaseStatus
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "shoping_button",
                                                          staticStyle: {
                                                            "margin-top":
                                                              "15px",
                                                            "margin-left": "0px"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.$router.push(
                                                                {
                                                                  name: "apply"
                                                                }
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Increase My Limit"
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "shoping_button",
                                                          staticStyle: {
                                                            "margin-top":
                                                              "15px",
                                                            "margin-left": "0px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Review increase limit"
                                                          )
                                                        ]
                                                      )
                                                ]
                                              : _vm._e()
                                          ]
                                    ],
                                    2
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.pcPayMenthod.pcNetQualificationStatus ==
                            "declined" ||
                          _vm.pcPayMenthod.pcNetQualificationStatus ==
                            "disabled"
                            ? [
                                _c("div", { staticClass: "apply-border" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info" },
                                    [
                                      !_vm.netPayable
                                        ? _c(
                                            "div",
                                            { staticClass: "net-term" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$router.push({
                                                        name: "profile"
                                                      })
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Open net term payment"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tooltipText.split(
                                                      ","
                                                    )[0]
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "info-name" },
                                              [
                                                _c("span", [
                                                  _vm._v("Net terms")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    class:
                                                      _vm.pcPayMenthod
                                                        .pcNetQualificationStatus ==
                                                      "declined"
                                                        ? "status color-red"
                                                        : "status color-brown"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("toFirstUpper")(
                                                          _vm.pcPayMenthod
                                                            .pcNetQualificationStatus
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "net-term" },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      cursor: "none",
                                                      "text-decoration": "none"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Contact Customer Service"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "12px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "To unlock the net term status"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.pcPayMenthod.pcNetQualificationStatus
                            ? [
                                _c("div", { staticClass: "apply-border" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info" },
                                    [
                                      !_vm.netPayable
                                        ? _c(
                                            "div",
                                            { staticClass: "net-term" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$router.push({
                                                        name: "profile"
                                                      })
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Open net term payment"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tooltipText.split(
                                                      ","
                                                    )[0]
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "info-name" },
                                              [
                                                _c("span", [
                                                  _vm._v("Net terms")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      effect: "dark",
                                                      content: _vm.tooltipText,
                                                      placement: "top"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning-outline",
                                                      staticStyle: {
                                                        "font-size": "20px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.netPayable
                                              ? _c(
                                                  "div",
                                                  { staticClass: "money_box" },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "money"
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              "$" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "numFormat"
                                                                  )(
                                                                    _vm
                                                                      .pcPayMenthod
                                                                      .totalCreditLimit
                                                                  )
                                                                )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          !_vm.pcPayMenthod
                                                            .exclusiveAvailableLimit
                                                            ? [
                                                                _vm.increaseStatus
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "shoping_button",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.$router.push(
                                                                              {
                                                                                name:
                                                                                  "apply"
                                                                              }
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Increase My Limit"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "shoping_button"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Review increase limit"
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-desc"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Credits available"
                                                          )
                                                        ]
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _vm.pcPayMenthod
                                                      .exclusiveAvailableLimit
                                                      ? _c("div", {
                                                          staticClass:
                                                            "line_between"
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.pcPayMenthod
                                                      .exclusiveAvailableLimit
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "money_box_right"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "money"
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _vm._v(
                                                                    "$" +
                                                                      _vm._s(
                                                                        _vm
                                                                          .pcPayMenthod
                                                                          .exclusiveAvailableLimit
                                                                      )
                                                                  )
                                                                ])
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "info-desc"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .pcPayMenthod
                                                                      .exclusiveBrandName
                                                                  ) + " Credits"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.pcPayMenthod
                                              .exclusiveAvailableLimit
                                              ? [
                                                  _vm.increaseStatus
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "shoping_button",
                                                          staticStyle: {
                                                            "margin-top":
                                                              "15px",
                                                            "margin-left": "0px"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.$router.push(
                                                                {
                                                                  name: "apply"
                                                                }
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Increase My Limit"
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "shoping_button",
                                                          staticStyle: {
                                                            "margin-top":
                                                              "15px",
                                                            "margin-left": "0px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Review increase limit"
                                                          )
                                                        ]
                                                      )
                                                ]
                                              : _vm._e()
                                          ]
                                    ],
                                    2
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.pcPayMenthod.pcNetQualificationStatus ===
                            "inReview" ||
                          _vm.pcPayMenthod.pcNetQualificationStatus === "frozen"
                            ? [
                                _c("div", { staticClass: "apply-border" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info" },
                                    [
                                      !_vm.netPayable
                                        ? _c(
                                            "div",
                                            { staticClass: "net-term" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$router.push({
                                                        name: "profile"
                                                      })
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Open net term payment"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tooltipText.split(
                                                      ","
                                                    )[0]
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "info-name" },
                                              [
                                                _c("span", [
                                                  _vm._v("Net terms")
                                                ]),
                                                _vm._v(" "),
                                                _vm.pcPayMenthod
                                                  .pcNetQualificationStatus !==
                                                "inReview"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        class:
                                                          _vm.pcPayMenthod
                                                            .pcNetQualificationStatus ===
                                                          "inReview"
                                                            ? "status color-gray"
                                                            : "status color-blue"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "toFirstUpper"
                                                            )(
                                                              _vm.pcPayMenthod
                                                                .pcNetQualificationStatus
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.pcPayMenthod
                                              .pcNetQualificationStatus ===
                                            "frozen"
                                              ? _c(
                                                  "div",
                                                  { staticClass: "net-term" },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          cursor: "none",
                                                          "text-decoration":
                                                            "none"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Contact Customer Service"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "12px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "To unlock the net term status"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "money_box" },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "money"
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              "$" +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "numFormat"
                                                                  )(
                                                                    _vm
                                                                      .pcPayMenthod
                                                                      .totalCreditLimit
                                                                  )
                                                                )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          !_vm.pcPayMenthod
                                                            .exclusiveAvailableLimit
                                                            ? [
                                                                _vm.increaseStatus
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "shoping_button",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.$router.push(
                                                                              {
                                                                                name:
                                                                                  "apply"
                                                                              }
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Increase My Limit"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "shoping_button"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Review increase limit"
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-desc"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Credits available"
                                                          )
                                                        ]
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _vm.pcPayMenthod
                                                      .exclusiveAvailableLimit
                                                      ? _c("div", {
                                                          staticClass:
                                                            "line_between"
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.pcPayMenthod
                                                      .exclusiveAvailableLimit
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "money_box_right"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "money"
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _vm._v(
                                                                    "$" +
                                                                      _vm._s(
                                                                        _vm
                                                                          .pcPayMenthod
                                                                          .exclusiveAvailableLimit
                                                                      )
                                                                  )
                                                                ])
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "info-desc"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .pcPayMenthod
                                                                      .exclusiveBrandName
                                                                  ) + " Credits"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                          ]
                                    ],
                                    2
                                  )
                                ])
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "wap-body" }, [
                    _vm.showMenu && _vm.firstListName
                      ? _c(
                          "div",
                          { staticClass: "wap-child" },
                          [
                            _c("h3", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.firstListName) +
                                  "\n            "
                              ),
                              _c("i", {
                                staticClass: "el-icon-arrow-left",
                                on: {
                                  click: function($event) {
                                    _vm.showMenu = false
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.currentItem["barType"] != "collection" ||
                            _vm.firstListName === "Featured"
                              ? _c(
                                  "h4",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.mobileGotoMenu(1)
                                      }
                                    }
                                  },
                                  [_vm._v("All " + _vm._s(_vm.firstListName))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-collapse",
                              {
                                attrs: { accordion: true },
                                on: { change: _vm.collapseChange },
                                model: {
                                  value: _vm.activeNames,
                                  callback: function($$v) {
                                    _vm.activeNames = $$v
                                  },
                                  expression: "activeNames"
                                }
                              },
                              _vm._l(_vm.secondListNew, function(item, index) {
                                return _c(
                                  "el-collapse-item",
                                  {
                                    key: index,
                                    attrs: {
                                      title: item.name,
                                      name: index.toString()
                                    }
                                  },
                                  [
                                    _c(
                                      "h4",
                                      {
                                        staticStyle: { "line-height": "30px" },
                                        on: {
                                          click: function($event) {
                                            return _vm.mobileGotoMenu(2, item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                All " +
                                            _vm._s(item.name) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.thirdListNew, function(obj, id) {
                                      return _c(
                                        "div",
                                        {
                                          key: id,
                                          staticClass: "wap-nav",
                                          on: {
                                            click: function($event) {
                                              return _vm.mobileGotoMenu(3, obj)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(obj.name) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "wap-list" },
                          [
                            _c("h4", [_vm._v("Categories for You")]),
                            _vm._v(" "),
                            _vm._l(_vm.navList, function(item, id) {
                              return item.cateName !== "Shop By Retailer"
                                ? _c(
                                    "p",
                                    {
                                      key: id,
                                      on: {
                                        click: function($event) {
                                          return _vm.showNextMenu(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      ),
                                      _c("i", {
                                        staticClass: "el-icon-arrow-right"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _vm.login
                              ? _c(
                                  "el-collapse",
                                  [
                                    _c(
                                      "el-collapse-item",
                                      [
                                        _c("template", { slot: "title" }, [
                                          _c("h4", [
                                            _c("i", {
                                              staticClass: "el-icon-user"
                                            }),
                                            _vm._v(
                                              "\n                  Your Account\n                "
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "Hello," + _vm._s(_vm.realname)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(_vm.menuList, function(item) {
                                          return !item.hidden
                                            ? _c("div", { key: item.name }, [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "first-vidi-menu",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.selectedMenu(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "menu-first"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.checkedMenu !==
                                                    item.name
                                                      ? _c("i", {
                                                          staticClass:
                                                            "el-icon-arrow-right"
                                                        })
                                                      : _c("i", {
                                                          staticClass:
                                                            "el-icon-arrow-down"
                                                        })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.firstMenuName === item.name
                                                  ? _c(
                                                      "div",
                                                      _vm._l(
                                                        item.childrenList,
                                                        function(secondMenu) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                secondMenu.key
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "second-vidi-menu",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.gotoRouter(
                                                                        2,
                                                                        secondMenu
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      secondMenu.name
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  : _vm._e()
                                              ])
                                            : _vm._e()
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.login
                              ? _c("h4", { on: { click: _vm.signOut } }, [
                                  _vm._v("Sign Out")
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                  ])
                ]
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "nav-body" },
            [
              _c(
                "div",
                { staticClass: "nav", on: { mouseleave: _vm.disableNextMenu } },
                [
                  _vm._l(_vm.navList, function(item, id) {
                    return item.cateName !== "Shop By Retailer"
                      ? _c(
                          "div",
                          {
                            key: id,
                            class: id == 0 ? "first" : "",
                            on: {
                              mouseover: function($event) {
                                return _vm.showNextMenu(item)
                              }
                            }
                          },
                          [
                            id == 0
                              ? _c(
                                  "div",
                                  {
                                    class: {
                                      "first-titel-seleted":
                                        item.id === _vm.currentItem.id
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.gotoCollection(1)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(item.name) +
                                        "\n        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            id != 0
                              ? _c(
                                  "div",
                                  {
                                    class: {
                                      "first-titel-seleted":
                                        item.id === _vm.currentItem.id
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.gotoProduct(1)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(item.name) +
                                        "\n        "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.showMenu ? _c("el-divider") : _vm._e(),
                  _vm._v(" "),
                  _vm.showMenu
                    ? _c(
                        "div",
                        {
                          staticClass: "categery-collection-menu-border",
                          on: { mouseleave: _vm.disableNextMenu }
                        },
                        [
                          _vm.firstListName == "Featured"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "categery-collection-menu-content"
                                },
                                [
                                  _c("div", { staticClass: "second-menu" }, [
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "second-left",
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function($event) {
                                              return _vm.gotoCollection(1)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "All " + _vm._s(_vm.firstListName)
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      _vm._l(_vm.secondListNew, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            class: {
                                              "second-content-selected":
                                                _vm.tempSecondId === item.id,
                                              "second-content":
                                                _vm.tempSecondId !== item.id
                                            },
                                            on: {
                                              mouseenter: function($event) {
                                                return _vm.changeThird(item)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "second-left-content",
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.gotoCollection(
                                                      2,
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("el-divider", {
                                    attrs: { direction: "vertical" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "third-menu" },
                                    _vm._l(_vm.thirdListNew, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "third-menu-border"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "third-content",
                                              attrs: {
                                                href: "javascript:void(0)"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.gotoCollection(
                                                    3,
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.firstListName != "Featured"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "categery-collection-menu-content"
                                },
                                [
                                  _c("div", { staticClass: "second-menu" }, [
                                    _vm.currentItem["barType"] != "collection"
                                      ? _c("div", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "second-left",
                                              attrs: {
                                                href: "javascript:void(0)"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.gotoProduct(1)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "All " +
                                                  _vm._s(_vm.firstListName)
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      _vm._l(_vm.secondListNew, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            class: {
                                              "second-content-selected":
                                                _vm.tempSecondId === item.id,
                                              "second-content":
                                                _vm.tempSecondId !== item.id
                                            },
                                            on: {
                                              mouseenter: function($event) {
                                                return _vm.changeThird(item)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "second-left-content",
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.gotoProduct(
                                                      2,
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("el-divider", {
                                    attrs: { direction: "vertical" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "third-menu" },
                                    _vm._l(_vm.thirdListNew, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "third-menu-border"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "third-content",
                                              attrs: {
                                                href: "javascript:void(0)"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.gotoProduct(
                                                    3,
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              !_vm.showMenu ? _c("el-divider") : _vm._e(),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMenu,
                    expression: "showMenu"
                  }
                ],
                staticClass: "footer"
              })
            ],
            1
          ),
      _vm._v(" "),
      false
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.showOnHold && (_vm.doubleShowOnHold || _vm.showMenuApp),
                  expression: "showOnHold && (doubleShowOnHold || showMenuApp)"
                }
              ],
              staticClass: "on-hold"
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/img/warning.png") }
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "13px" },
                  on: { click: _vm.retailerCheck }
                },
                [_vm._v("Start Verification!")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("sdrLogin", {
        attrs: { showSdrLoginDialog: _vm.showSdrLoginDialog },
        on: {
          sdrLogin: _vm.sdrLogin,
          closeSdrLoginDialog: _vm.closeSdrLoginDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "on-hold-text" }, [
      _c("label", [_vm._v("Action required! ")]),
      _vm._v("\n      Verify as a retailer, increase your term.")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-053465a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053465a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/nav.vue
// module id = null
// module chunks = 